export const Companies = {
    Spiris: "Spiris",
}